// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"2008f2c2","46":"95484928","130":"b8b76aad","163":"a13e686f","223":"072971bc","375":"63baf8b1","423":"768fd40b","455":"89d33f27","488":"328ec08b","575":"fc9e20d7","596":"ddd09194","768":"267a6c14","977":"e05582e0"}[chunkId] + ".chunk.js";
};